import { render, staticRenderFns } from "./FloatingChatIcon.vue?vue&type=template&id=75126b53&scoped=true"
import script from "./FloatingChatIcon.vue?vue&type=script&lang=js"
export * from "./FloatingChatIcon.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/chat.css?vue&type=style&index=0&id=75126b53&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75126b53",
  null
  
)

export default component.exports